import { useEffect } from 'react';

export const SCROLLBAR_WIDTH_VAR = '--scrollbar-width';

/**
 * Publishes the page scrollbar's width on <html> as `--scrollbar-width`, so the shell can take it
 * back out of its right padding. Zero for overlay scrollbars. Re-measured on resize because the
 * gutter's CSS width changes with the browser zoom level.
 */
export const useScrollbarWidthVar = (): void => {
    useEffect(() => {
        const root = document.documentElement;
        const measure = () => {
            const width = Math.max(0, window.innerWidth - root.clientWidth);
            root.style.setProperty(SCROLLBAR_WIDTH_VAR, `${width}px`);
        };
        measure();
        window.addEventListener('resize', measure);
        return () => {
            window.removeEventListener('resize', measure);
            root.style.removeProperty(SCROLLBAR_WIDTH_VAR);
        };
    }, []);
};
